import { memo, useMemo } from 'react';

import FormGuideAvatar from '../../../FormGuideAvatar';
import { useNumberOfMatches } from '../hooks';

import type { FormGuideMatch } from '@shared-types/form-guide.types';
import type { Team } from '@shared-types/match.types';

import * as classes from '../styles.module.scss';

/**
 * A view that admit the use of placeholders
 */
const StandardView = ({ matches, team }: { matches: FormGuideMatch[]; team: Team }) => {
  const { numberOfMatches } = useNumberOfMatches(false);
  const matchesPlaceholders = useMemo(
    () => Array.from({ length: matches ? numberOfMatches - matches.length : numberOfMatches }, (_, i) => i),
    [matches, numberOfMatches],
  );

  return (
    <ul>
      {matchesPlaceholders.map((i) => (
        <li key={`placeholder-${i}`}>
          <div className={classes.placeholder} />
        </li>
      ))}
      {matches?.toReversed().map(({ match, outcome }, i) => (
        <li key={match.id}>
          <FormGuideAvatar outcome={outcome} match={match} teamId={team.id} underline={i === matches.length - 1} />
        </li>
      ))}
    </ul>
  );
};

export default memo(StandardView);
